<template>
  <div class="container mt-4">
    <h1 class="text-center mb-4">🎨 Place de marché Pixel Art</h1>

    <!-- État de chargement -->
    <div v-if="loading" class="text-center p-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Chargement...</span>
      </div>
    </div>

    <!-- Erreur -->
    <div v-else-if="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>

    <!-- Aucune mosaïque publique -->
    <div v-else-if="publicMosaics.length === 0" class="alert alert-info text-center" role="alert">
      Aucune mosaïque publique disponible pour le moment.
    </div>

    <!-- Liste des mosaïques publiques -->
    <div v-else>
      <section class="mb-5">
        <h2 class="mb-3">🌟 Toutes les créations publiques ({{ publicMosaics.length }})</h2>
        <div class="row">
          <div 
            v-for="mosaic in publicMosaics" 
            :key="mosaic.id"
            class="col-md-4 col-lg-3 mb-4"
          >
            <div class="card h-100 shadow-sm pixel-art-card">
              <router-link :to="'/place/carde/' + mosaic.id" class="text-decoration-none">
                <img 
                  :src="mosaic.image" 
                  class="card-img-top pixel-art-img" 
                  :alt="mosaic.name"
                  style="height: 250px; object-fit: contain; background-color: #f8f9fa;"
                />
              </router-link>
              <div class="card-body">
                <h5 class="card-title text-truncate">{{ mosaic.name }}</h5>
                <p class="card-text text-muted small">
                  Par <strong>{{ mosaic.author }}</strong>
                </p>
                <p class="card-text text-muted small">
                  {{ mosaic.creationDate }}
                </p>
                <router-link 
                  :to="'/place/carde/' + mosaic.id" 
                  class="btn btn-primary btn-sm w-100"
                >
                  Voir les détails
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PixelArtMarketplace',
  data() {
    return {
      publicMosaics: [],
      loading: true,
      error: null
    };
  },
  mounted() {
    this.fetchPublicMosaics();
  },
  methods: {
    async fetchPublicMosaics() {
      try {
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await axios.get(`${API_URL}/api/mosaics/public`);
        
        this.publicMosaics = response.data;
        this.loading = false;
      } catch (err) {
        console.error('Erreur lors du chargement des mosaïques publiques:', err);
        this.error = 'Impossible de charger les mosaïques publiques';
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.pixel-art-img {
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

.pixel-art-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.pixel-art-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-title {
  font-size: 1.1rem;
  font-weight: bold;
}
</style>